import { create } from 'zustand';
import { StudentInfo } from '@/request/interface/login';

export interface UserState {
  user: StudentInfo | Record<string, string>;
  setUser: (user: StudentInfo) => void;
  userLoaded: boolean;
}

const useUserStore = create<UserState>((set) => ({
  user: {},
  userLoaded: false,
  setUser: (user: StudentInfo) => set({ user, userLoaded: true }),
}));

export default useUserStore;
